import { render, staticRenderFns } from "./WarehousesUtilizationList.vue?vue&type=template&id=8e6dce08&"
import script from "./WarehousesUtilizationList.vue?vue&type=script&lang=ts&"
export * from "./WarehousesUtilizationList.vue?vue&type=script&lang=ts&"
import style0 from "./WarehousesUtilizationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports